











































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import BillApi from '@/api/bill'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import PageLayout from '@/components/page/PageLayout.vue'
import { uuid, dateFormat, throttle, download } from '@/utils/util'
import moment from 'moment'
import EvaluateApi from '@/api/evaluate'
import Task from '@/web-task'
import { triggerWindowResizeEvent } from '@/utils/util'
import cloneDeep from 'lodash/cloneDeep'
import { initOrderDetail } from '@/web-task/utils/order'
import { wsURL } from '@/api/url'
import setting from '@/core/setting'
import InvestigateApi from '@/api/investigate'
import Info from '@/components/task/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import { formatTime, formatDate, format } from '@/web-task/filter'
import { zeroUnit } from '@/web-task/utils'

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	name: 'billTaskDetail',
	components: {
		PageLayout,
		Info,
		InfoRow,
	},
})
export default class QueryList extends Vue {
	private addResurveyVisible: boolean = false
	private taskLog: any = []
	private taskLogVisible: boolean = false
	private order: any = ''
	private invoices: any = ''
	private injured: any = ''
	private task: any = {}
	private exporting: boolean = false
	private active: any = 0
	private columns: any = [
		{
			title: '类别',
			align: 'center',
			dataIndex: 'itemName',
			customRender: (value: any, row: any, index: any) => {
				const obj = {
					children: value,
					attrs: {
						rowSpan: row.span,
					},
				}
				return obj
			},
		},
		{
			title: '总金额',
			align: 'center',
			dataIndex: 'itemAmount',
			customRender: (value: any, row: any, index: any) => {
				const obj = {
					children: value,
					attrs: {
						rowSpan: row.span,
					},
				}
				return obj
			},
		},
		{
			title: '项目名称',
			align: 'center',
			dataIndex: 'auxItemName',
		},
		{
			title: '规格',
			align: 'center',
			dataIndex: 'auxItemSpec',
		},
		{
			title: '单价',
			align: 'center',
			dataIndex: 'auxItemStd',
		},
		{
			title: '数量',
			align: 'center',
			dataIndex: 'quantity',
		},
		{
			title: '金额',
			align: 'center',
			dataIndex: 'amount',
		},
		{
			title: '备注',
			align: 'center',
			dataIndex: 'remark',
		},
	]
	private queryInfo: any = {}
	private authInfo: any = {}

	private init() {
		this.order = ''
		this.invoices = ''
		this.getDetail()
	}

	private activated() {
		this.init()
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.$nextTick(() => {
			this.init()
		})
		next()
	}

	private get isSuccess() {
		return this.order.orderStatus === '10'
	}

	private get isFail() {
		return this.order.orderStatus === '11'
	}

	private get tableData() {
		const info = this.invoices[this.active]
		if (!info) {
			return []
		}
		const arr: any = []
		const details = cloneDeep(info.details)
		// 	details[0].auxDetails = [
		// 					{auxItemQuantity: 2, auxItemAmount: 2, auxItemRemark: '备注', id: 1},
		// 					{auxItemQuantity: 3, auxItemAmount: 4, auxItemRemark: '备注', id: 2},
		// ]
		// 	details[1].auxDetails = [
		// 			{auxItemQuantity: 2, auxItemAmount: 2, auxItemRemark: '备注', id: 3},
		// 			{auxItemQuantity: 3, auxItemAmount: 4, auxItemRemark: '备注', id: 4},
		// 	]
		// 	details[2].auxDetails = [
		// 			{auxItemQuantity: 2, auxItemAmount: 2, auxItemRemark: '备注', id: 5},
		// 			{auxItemQuantity: 3, auxItemAmount: 4, auxItemRemark: '备注', id: 6},
		// 	]
		for (const item of details) {
			let auxDetails: any = [{}]
			if (item.auxDetails && item.auxDetails.length) {
				auxDetails = item.auxDetails
			}
			for (const [index, aux] of auxDetails.entries()) {
				aux.itemName = item.itemName
				aux.itemAmount = zeroUnit(item.itemAmount, '元')
				aux.auxItemStd = zeroUnit(aux.auxItemStd, '元')
				aux.quantity = aux.auxItemQuantity || item.itemQuantity
				aux.amount = zeroUnit(aux.auxItemAmount || item.itemAmount, '元')
				aux.remark = aux.auxItemRemark || item.comment
				aux.id = aux.id || item.id
				aux.span = index === 0 ? auxDetails.length : 0
				arr.push(aux)
			}
		}
		// console.log(arr)
		return arr
	}
	private soFarDate(date: any) {
		if (date) {
			if (date < SO_FAR) {
				return moment(this.injured.injuredInfo.leaveDate).format('YYYY-MM-DD')
			} else {
				return '至今'
			}
		} else {
			return
		}
	}

	private dateFormat(start: any, end: any) {
		return dateFormat(start, end)
	}

	private get billInfo() {
		const info = this.invoices[this.active]
		const setting = this.$store.state.setting
		if (!info) {
			return ''
		}
		let arr = [
			{ label: '电子票据名称', value: info.einvoiceName },
			{ label: '电子票据代码', value: info.einvoiceCode },
			{ label: '电子票据号码', value: info.einvoiceNumber },
			{ label: '校验码', value: info.randomNumber },
			{
				label: '是否已打印纸票',
				value: setting.yesNoMap[Number(info.isExchangePaper)],
			},
			{ label: '纸质票据代码', value: info.paperInvoiceCode },
			{ label: '纸质票据号码', value: info.paperInvoiceNumber },
			{ label: '是否开红票', value: setting.yesNoMap[Number(info.isReversal)] },
			{ label: '红票票据代码', value: info.reversalInvoiceCode },
			{ label: '红票票据号码', value: info.reversalInvoiceNumber },
			{ label: '总金额', value: zeroUnit(info.totalAmount, '元') },
			{
				label: '开票日期',
				value: format(info.issueDate, 'YYYY-MM-DD'),
			},
			{
				label: '开票时间',
				value: info.issueTime,
			},
			{ label: '医疗卫生机构类别', value: info.orgType },
			{ label: '医疗机构代码', value: info.invoicingPartyCode },
			{ label: '医疗机构名称', value: info.invoicingPartyName },
			{ label: '就诊人名称', value: info.payerPartyName },
			{ label: '就诊人身份证号', value: info.payerPartyCode },
			{ label: '医保类型', value: info.medicalInsuranceType },
			{ label: '就诊类型', value: setting.medicalTypeMap[info.medicalType] },
			{ label: '科室', value: info.department },
			{ label: '门诊号', value: info.patientNumber },
			{ label: '病例号', value: info.caseNumber },
			{ label: '住院号', value: info.hospitalizationNumber },
			{ label: '住院日期', value: formatDate(info.inHospitalDate) },
			{ label: '出院日期', value: formatDate(info.outHospitalDate) },
			{ label: '个人账户支付', value: zeroUnit(info.accountPayAmount, '元') },
			{ label: '个人支付', value: zeroUnit(info.ownPayAmount, '元') },
			{ label: '个人自付', value: zeroUnit(info.selfPaymentAmount, '元') },
			{ label: '其他支付', value: zeroUnit(info.otherPayAmount, '元') },
			{
				label: '是否已入账',
				value: setting.yesNoMap[Number(info.isAccounted)],
			},
			{ label: '入账日期', value: formatDate(info.accDate) },
			{ label: '入账金额', value: zeroUnit(info.accAmount, '元') },
			{ label: '备注', value: info.remark },
		]
		arr = arr.filter((item: any) => !!item.value)
		return arr
	}

	private getDetail() {
		return BillApi.getDetail(this.$route.params.orderId).then((res: any) => {
			const order = res.data.order
			this.order = order
			this.invoices = res.data.invoices
			const queryInfo = {
				title: '查询信息',
				children: [
					{ label: '查询公司', value: order.companyName },
					{ label: '订单号', value: order.orderNo },
					{
						label: '查询类型',
						value: this.$store.state.setting.invoiceTasktypeMap[order.taskType],
					},
					{ label: '查询时间', value: formatTime(order.createTime) },
					{ label: '就诊人姓名', value: order.injuredName },
					{ label: '就诊人电话', value: order.injuredPhone },
					{ label: '就诊人身份证号', value: order.idCard },
					{ label: '就诊人机构名称', value: order.hospital },
					{ label: '发票开始时间', value: formatDate(order.startIssueDate) },
					{ label: '发票结束时间', value: formatDate(order.endIssueDate) },
					{ label: '查询人姓名', value: order.creatorName },
					{ label: '查询人电话号码', value: order.creatorPhone },
					{
						label: '查询状态',
						value: this.$store.state.setting.invoiceTaskStatusMap[
							order.orderStatus
						],
					},
				],
			}
			queryInfo.children = queryInfo.children.filter(
				(item: any) => !!item.value
			)
			this.queryInfo = queryInfo
			this.authInfo = {
				title: '授权信息',
				children: [
					{ label: '授权人姓名', value: order.certigier },
					{ label: '授权人电话', value: order.certigierPhone },
					{ label: '授权文件', value: order.authorizeInfoUrl, slot: 'url' },
				],
			}
		})
	}
}
